import React, { Component } from 'react';
import ReactGA from 'react-ga';
import {
  BrowserRouter as Router,
  withRouter,
  Route,
  Switch,
} from 'react-router-dom';


import './App.css';
import Login from './components/login/Login';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import Contact from './pages/Contact';
import Disclosure from './pages/Disclosure';
import Privacy from './pages/Privacy';
import TermsOfService from './pages/TermsOfService';
import Gif from './pages/Gif';
import Jivni from './pages/jivini';
import Stori4u from './pages/Story4u';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ToastContainer from './components/common/ToastContainer';
import Listing from './pages/survey/listing.js';
import Survey from './pages/survey/survey.js';
import Notfound from './pages/Notfound';
import JgdSatsangList from './pages/JgdSatsangList';
import GaneshJi from './Gif/GaneshJi';
import CreateGif from './Gif/CreateGif';
import MyPage from './pages/MyPage';
import AddUpdateSatsang from './components/satsang/AddUpdate';
import Archive from './pages/Archive';
import CreateUser from './components/user/CreateUser';
import UsersList from './pages/UsersList';
import PWAInstallPrompt from './components/PWAInstallPrompt/PWAInstallPrompt';

function initializeReactGA() {
  ReactGA.initialize('UA-175245159-1');
  ReactGA.pageview('/homepage');
}

function initializeReactGA() {
  ReactGA.initialize('UA-175800281-1');
  ReactGA.pageview('/homepage');
}

class App extends Component {
  render() {
    
    return (
      <Router>
        <div>
          <Navbar />
          <ToastContainer />
          <PWAInstallPrompt />
          <div style={{ minHeight: '672px' }}>
            <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/login" component={Login} />
            <Route exact path="/gif" component={Gif} />
            <Route exact path="/gif/jgd" component={Stori4u} />
            <Route exact path="/gif/jgd/:id" component={Stori4u} />
            <Route exact path="/gif/sjgd" component={GaneshJi} />
            <Route exact path="/gif/sjgd/:id" component={GaneshJi} />
            <Route exact path="/gif/create" component={CreateGif} />
            <Route exact path="/gif/:id" component={CreateGif} />
            <Route path="/myPage" component={MyPage} />
            <Route path="/about" component={About} />
            <Route path="/contact" component={Contact} />
            <Route path="/privacy" component={Privacy} />
            <Route path="/terms" component={TermsOfService} />
            <Route path="/disclosure" component={Disclosure} />
            <Route exact path="/jgd-satsang" component={JgdSatsangList} />
            <Route exact path="/jgd-story" component={JgdSatsangList} />
            <Route exact path="/badela-satsang" component={JgdSatsangList} />
            <Route exact path="/prarthna" component={JgdSatsangList} />
            <Route exact path="/sadhakon-ki-kalam-se" component={JgdSatsangList} />
            <Route exact path="/aantarik-prarthna" component={JgdSatsangList} />
            <Route exact path="/jivani" component={JgdSatsangList} />
            <Route exact path="/navin-suchnaye" component={JgdSatsangList} />
            <Route exact path="/pramukh-antargat-sandesh" component={JgdSatsangList} />
            <Route exact path="/badela-dham" component={JgdSatsangList} />
            <Route exact path="/nij-anubhav" component={JgdSatsangList} />
            <Route exact path="/jgd-pic" component={JgdSatsangList} />
            <Route exact path="/badela-pic" component={JgdSatsangList} />
            <Route exact path="/world-message" component={JgdSatsangList} />
            <Route exact path="/kumbh-magh-shakahar" component={JgdSatsangList} />
            <Route path="/jgd-satsang/:id" component={Jivni} />
            <Route path="/badela-satsang/:id" component={Jivni} />
            <Route path="/prarthna/:id" component={Jivni} />
            <Route path="/sadhakon-ki-kalam-se/:id" component={Jivni} />
            <Route path="/aantarik-prarthna/:id" component={Jivni} />
            <Route path="/jivani/:id" component={Jivni} />
            <Route path="/jgd-story/:id" component={Jivni} />
            <Route exact path="/navin-suchnaye/:id" component={Jivni} />
            <Route exact path="/pramukh-antargat-sandesh/:id" component={Jivni} />
            <Route exact path="/badela-dham/:id" component={Jivni} />
            <Route exact path="/nij-anubhav/:id" component={Jivni} />
            <Route exact path="/jgd-pic/:id" component={Jivni} />
            <Route exact path="/badela-pic/:id" component={Jivni} />
            <Route exact path="/world-message/:id" component={Jivni} />
            <Route exact path="/kumbh-magh-shakahar/:id" component={Jivni} />
            <Route exact path="/satsang/add" component={AddUpdateSatsang} />
            <Route path="/satsang/:id" component={AddUpdateSatsang} />
            <Route exact path="/archive" component={Archive} />
            <Route exact path="/survey" component={Listing} />
            <Route path="/survey/:id" component={Survey} />
            <Route exact path="/create-user" component={CreateUser} />
            <Route exact path="/users" component={UsersList} />
            <Route component={Notfound} />
            </Switch>
          </div>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js